# This gets automatically populated bij gulp

exports.date = 1453498773
exports.branch = "tisho/animation-paths"
exports.hash = "40ae942"
exports.build = 1374
exports.version = "#{exports.branch}/#{exports.hash}"



/** WEBPACK FOOTER **
 ** ./build/Version.coffee
 **/